'use client';

import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ScoreRefreshContextType {
    refreshTrigger: number;
    triggerRefresh: () => void;
    weightProfileForClear: any | null;
    triggerClearScores: (weightProfile: any) => void;
}

const ScoreRefreshContext = createContext<ScoreRefreshContextType | undefined>(undefined);

export const ScoreRefreshProvider = ({ children }: { children: ReactNode }) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [weightProfileForClear, setWeightProfileForClear] = useState<any | null>(null);

    const triggerRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    const triggerClearScores = useCallback((weightProfile: any) => {
        setWeightProfileForClear(weightProfile);
        // Reset after a short delay to allow hooks to react
        setTimeout(() => setWeightProfileForClear(null), 100);
    }, []);

    return (
        <ScoreRefreshContext.Provider value={{ refreshTrigger, triggerRefresh, weightProfileForClear, triggerClearScores }}>
            {children}
        </ScoreRefreshContext.Provider>
    );
};

export const useScoreRefresh = () => {
    const context = useContext(ScoreRefreshContext);
    if (context === undefined) {
        throw new Error('useScoreRefresh must be used within a ScoreRefreshProvider');
    }
    return context;
};
